module.exports = __webpack_public_path__ + "static/media/bg_1.f7de43c6.jpg";